<template>
  <div class="sidebar">
    <div class="logo">
      <span v-if="!collapsed">RBAC管理系统</span>
      <span v-else>R</span>
    </div>
    <el-menu
      :default-active="activeMenu"
      :collapse="collapsed"
      :unique-opened="true"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      router
    >
      <template v-for="menu in menus">
        <el-submenu v-if="menu.children && menu.children.length" :key="menu.id" :index="menu.path">
          <template slot="title">
            <i :class="menu.icon || 'el-icon-menu'"></i>
            <span>{{ menu.name }}</span>
          </template>
          <el-menu-item
            v-for="child in menu.children"
            :key="child.id"
            :index="child.path"
          >
            <i :class="child.icon || 'el-icon-document'"></i>
            <span slot="title">{{ child.name }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else :key="menu.id" :index="menu.path">
          <i :class="menu.icon || 'el-icon-menu'"></i>
          <span slot="title">{{ menu.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Sidebar',
  computed: {
    ...mapGetters(['menus', 'sidebarCollapsed']),
    collapsed() {
      return this.sidebarCollapsed
    },
    activeMenu() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.sidebar {
  height: 100%;
}
.logo {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  background-color: #263445;
  overflow: hidden;
}
.el-menu {
  border-right: none;
}
</style>
